import React from 'react';
import SkeletonBlock from './common/SkeletonBlock';
import './HomePageSkeleton.css';

// Hero placeholder rendered at the hero's DOM position (above
// AnnouncementBanner) while homepage data is loading. This reserves
// the hero's vertical space so that when the real HeroSection mounts
// after the API responds, it fills the reserved area instead of
// pushing all content below it down — preventing a large CLS.
// Heights are kept in sync with HeroSection.css and
// HomePageSkeleton.css (.home-page-skeleton__hero min-height: 400px).
const HeroSkeleton = () => (
  <div className="home-page-skeleton__hero" aria-hidden="true">
    <div className="container home-page-skeleton__hero-inner">
      <div className="home-page-skeleton__hero-info">
        <SkeletonBlock width="120px" height="1.5rem" radius="999px" />
        <SkeletonBlock width="70%" height="2.5rem" radius="0.8rem" />
        <SkeletonBlock width="90%" height="1rem" radius="0.6rem" />
        <SkeletonBlock width="80%" height="1rem" radius="0.6rem" />
        <SkeletonBlock width="140px" height="48px" radius="var(--radius-md)" />
      </div>
      <div className="home-page-skeleton__hero-cover">
        <SkeletonBlock width="280px" height="420px" radius="var(--radius-lg)" />
      </div>
    </div>
  </div>
);

export default HeroSkeleton;
